import type { DashboardLayoutProps } from '@classroom-ai/ui/layouts/dashboard';

import { DashboardLayout as UiDashboardLayout } from '@classroom-ai/ui/layouts/dashboard';

import { StudentClassProvider } from 'src/class/class-provider';

import { navData } from '../nav-config-dashboard';
import { ClassSwitcher } from '../class-switcher';

// ----------------------------------------------------------------------

export { DashboardContent } from '@classroom-ai/ui/layouts/dashboard';

/**
 * Student wrapper around the shared dashboard layout — injects this app's
 * nav data and the app-wide class switcher.
 *
 * `StudentClassProvider` wraps the whole layout so both the header switcher
 * (`ClassSwitcher` in the header `centerArea` slot) and the page content
 * (`children`) share one active-class selection.
 */
export function DashboardLayout({ slotProps, ...other }: DashboardLayoutProps) {
  return (
    <StudentClassProvider>
      <UiDashboardLayout
        {...other}
        slotProps={{
          nav: { data: navData },
          header: { slots: { centerArea: <ClassSwitcher /> } },
          ...slotProps,
        }}
      />
    </StudentClassProvider>
  );
}
